import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import { withTranslation } from 'react-i18next';
import PersonIcon from '@mui/icons-material/Person';
import { GapGrid } from 'components/common/CommonStyles';

export const OfferPartnerShareholderParentRowComponent = ({
  shareholder,
  t,
  openMasterPartner,
  openDocumentPartner,
  masterPartnerApp,
  viewShareholderPhone
}) => {
  return (
    <TableRow>
      <TableCell colSpan={7} sx={{ border: 'none' }}>
        <GapGrid container direction='row' gap={2} justifyContent='space-between' alignItems='center' px={4}>
          <div>
            <strong>{t('OfferEdit.Client.Shareholder.UniqueID')}:</strong> <span>{shareholder.uniqueID || ''}</span>
          </div>
          <div>
            <strong>{t('OfferEdit.Client.Shareholder.Name')}:</strong> <span>{shareholder.shareHolderPartnerName || ''}</span>
          </div>
          {viewShareholderPhone && (
            <div>
              <strong>{t('OfferEdit.Client.Shareholder.Phone')}:</strong> <span>{shareholder.shareHolderPhoneNumber || ''}</span>
            </div>
          )}
          <div>
            <strong>{t('OfferEdit.Client.Shareholder.Percent')}:</strong>{' '}
            <span>{t('PERCENT_NUMBER', { number: shareholder.sharePercent })}%</span>
          </div>
          {masterPartnerApp ? (
            <IconButton
              color='primary'
              variant='text'
              size='small'
              tooltip={t('Tooltips.EditPartner')}
              disabled={shareholder.shareHolderPartnerId === null && shareholder.documentPartnerId === null}
              onClick={
                !shareholder.documentPartnerId
                  ? openMasterPartner(shareholder.shareHolderPartnerId)
                  : openDocumentPartner(shareholder.documentPartnerId, shareholder.shareHolderPartnerName, 'Shareholder L2')
              }
            >
              <PersonIcon />
            </IconButton>
          ) : null}
        </GapGrid>
      </TableCell>
    </TableRow>
  );
};

OfferPartnerShareholderParentRowComponent.propTypes = {
  shareholder: PropTypes.object.isRequired,
  t: PropTypes.func,
  openMasterPartner: PropTypes.func.isRequired,
  openDocumentPartner: PropTypes.func.isRequired,
  masterPartnerApp: PropTypes.bool,
  isAssociatedPartner: PropTypes.bool.isRequired,
  viewShareholderPhone: PropTypes.bool.isRequired
};
export default withTranslation()(OfferPartnerShareholderParentRowComponent);
